import { supabase } from '../lib/supabase';

export const complianceService = {
  async getComplianceMetrics() {
    try {
      const { data: violations, error: violationsError } = await supabase
        ?.from('compliance_violations')
        ?.select('severity, violation_status')
        ?.eq('violation_status', 'identified');

      if (violationsError) throw violationsError;

      const criticalCount = violations?.filter(v => v?.severity === 'critical')?.length || 0;
      const totalViolations = violations?.length || 0;

      const { data: reports, error: reportsError } = await supabase
        ?.from('compliance_reports')
        ?.select('overall_compliance_score')
        ?.order('created_at', { ascending: false })
        ?.limit(1)
        ?.single();

      const complianceScore = reports?.overall_compliance_score || 0;

      return [
        {
          title: "Overall Compliance Score",
          value: `${complianceScore}%`,
          subtitle: "Target: 95%",
          status: complianceScore >= 95 ? "compliant" : complianceScore >= 85 ? "warning" : "critical",
          trend: 0,
          icon: "Shield"
        },
        {
          title: "Active Violations",
          value: totalViolations?.toString(),
          subtitle: `${criticalCount} critical`,
          status: criticalCount > 0 ? "critical" : totalViolations > 0 ? "warning" : "compliant",
          trend: 0,
          icon: "AlertTriangle"
        },
        {
          title: "Pending Deadlines",
          value: "0",
          subtitle: "All current",
          status: "compliant",
          trend: 0,
          icon: "Clock"
        }
      ];
    } catch (error) {
      console.error('Error fetching compliance metrics:', error);
      return [];
    }
  },

  async getComplianceTrends() {
    try {
      const { data, error } = await supabase
        ?.from('compliance_reports')
        ?.select('period_start, overall_compliance_score, total_violations')
        ?.order('period_start', { ascending: true })
        ?.limit(6);

      if (error) throw error;

      return data?.map(report => ({
        month: new Date(report?.period_start)?.toLocaleDateString('en-US', { month: 'short', year: '2-digit' }),
        overall: report?.overall_compliance_score || 0,
        violations: report?.total_violations || 0
      })) || [];
    } catch (error) {
      console.error('Error fetching compliance trends:', error);
      return [];
    }
  },

  async getDepartmentCompliance() {
    try {
      const { data, error } = await supabase
        ?.from('report_department_breakdown')
        ?.select('department, compliance_score, violations_count')
        ?.order('compliance_score', { ascending: false });

      if (error) throw error;

      return data?.map(dept => ({
        name: dept?.department,
        score: dept?.compliance_score || 0,
        violations: dept?.violations_count || 0
      })) || [];
    } catch (error) {
      console.error('Error fetching department compliance:', error);
      return [];
    }
  }
};

export default complianceService;